import {createActionGroup, emptyProps, props} from "@ngrx/store";
import {AiChatContext} from "../../generated-sources/api/ai/model/ai-chat-context";
import {AiEntityReference} from "../../generated-sources/api/ai/model/ai-entity-reference";
import {AiSuggestedAction} from "../../generated-sources/api/ai/model/ai-suggested-action";

export const AiChatActions = createActionGroup({
  source: "AI Chat",
  events: {
    // Panel
    togglePanel: emptyProps(),
    openPanel: emptyProps(),
    closePanel: emptyProps(),

    // Chat
    newConversation: emptyProps(),
    sendMessage: props<{ message: string; context: AiChatContext | null }>(),
    streamChunk: props<{ text: string }>(),
    streamToolCall: props<{ tool: string; status: string }>(),
    streamEntityReferences: props<{ refs: AiEntityReference[] }>(),
    streamSuggestedActions: props<{ actions: AiSuggestedAction[] }>(),
    streamComplete: emptyProps(),
    streamError: props<{ message: string }>(),
  },
});
